export default '/static/frontend/ReachDigital/12gobiking/dist/assets/billink-dc04101e.png'